import React from "react";
import CrownResidences from "../components/projects/CrownResidences";
import { getSEOData } from "../utils/seo";

export default () => {
  const seoData = getSEOData("crown-residence-luxury-apartments-koyambedu-chennai");
  return <CrownResidences seoData={seoData} />;
};
